<template>
	<div class="relative max-w-full w-max">
		<NuxtImg
			:src="category.Files[0]?.ImagePath"
			:alt="`Category ${category.Name}`"
			class="max-h-full w-full object-cover cursor-pointer !aspect-[2/3]"
			:loading="lazyLoading ? 'lazy' : 'eager'"
			:preload="!lazyLoading"
			width="364"
			height="546"
		/>
	</div>
	<Button
		:link="link"
		button-style="button-link"
		class="mt-4 uppercase font-heldane font-normal"
	>
		{{ category.Name }}
	</Button>
</template>

<script setup lang="ts">
import type { CategoryWithFiles } from "@nwt/norce-pwa/dist/runtime/types/api/category/category";

interface Props {
	category: CategoryWithFiles;
	lazyLoading: boolean | undefined;
	link: string;
}

defineProps<Props>();
</script>
